import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {getMatrix} from "../../store/cabinet/action";
import CabinetMatrixMain from "../../components/cabinetMatrixMain";
import {useNavigate} from "react-router-dom";
import CabinetMatrixSellWarningModal from "../../components/cabinetMatrixSellWarningModal";
import CabinetMatrixSellModal from "../../components/cabinetMatrixSellModal";
import CabinetMatrixSellSuccessModal from "../../components/cabinetMatrixSellSuccessModal";
import CabinetMatrixBuyModal from "../../components/cabinetMatrixBuyModal";



const CabinetMatrixPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(() => {
        dispatch(getMatrix());
    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetMatrixMain/>
                <CabinetMatrixSellWarningModal/>
                <CabinetMatrixSellSuccessModal/>
                <CabinetMatrixSellModal/>
                <CabinetMatrixBuyModal/>
            </div>
        </section>
    );
};

export default CabinetMatrixPage;
